import { TickIcon } from '@shapeable/icons';
import { 
  createSliceLayout,
  SliceBlockGrid,
  SliceBlockThumbnailGrid,
  SliceBlockThumbnailGridProps,
  SliceImageBlocks,
  SliceIntro,
  SliceLatestInsights,
  SliceLatestInsightsProps,
  SlicePersonBioGrid,
  SlicePersonBioGridProps,
  SliceQuestion,
  SliceQuestionProps,
} from '@shapeable/ui';

export const SliceLayoutKeyPillars = createSliceLayout(
  SliceImageBlocks, {
    verticalPadding: 'small',
  }
);

export const SliceLayoutIntro = createSliceLayout(
  SliceIntro, {
    verticalPadding: 'medium',
  }
);

export const SliceLayoutPeople = createSliceLayout<SlicePersonBioGridProps>(
  SlicePersonBioGrid, {
    verticalPadding: 'small',
    props: {
      transform: '',
    }
  }
); 

export const SliceLayoutQuestion = createSliceLayout<SliceQuestionProps>(
  SliceQuestion, {
    boundary: 'content',
    props: {
      iconComponent: TickIcon,
      duration: 500,
      colors: {
        text: 'light',
        fill: 'light',
      },
    }
  }
);

export const SliceLayoutBlockGrid = createSliceLayout(
  SliceBlockGrid, {
    verticalPadding: 'content',
    boundary: 'content',
  }
);

export const SliceLayoutBlockThumbnailCardGrid3Columns = createSliceLayout<SliceBlockThumbnailGridProps>(
  SliceBlockThumbnailGrid, {
    verticalPadding: 'none',
    boundary: 'none',
    props: {
      variant: 'card',
      columns: 0,
      spacing: 0.5,
      tabletMinColumns: 2,
      desktopAutoColumns: 3,
      desktopMinColumns: 3,
      desktopFullHdMinColumns: 3,
      desktopLargeMinColumns: 3,
      desktopLargeAutoColumns: 3,
      desktopFullHdAutoColumns: 3
    }
  }
);

export const SliceLayoutLatestInsights = createSliceLayout<SliceLatestInsightsProps>(
  SliceLatestInsights, {
    boundary: 'content-bleed',
    verticalPadding: 'small',
    props: {
      showHeader: false,
    }
  }
);